import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	grid-column-start: 1;
	grid-column-end: 4;
	margin: 0 0 28px;
	width: 100%;
	text-align: center;
	background-color: ${palette('white')};

	${minWidth('tablet')} {
		grid-column-start: 2;
		margin: 28px 0;
	}
`;
